import {useMutation} from '@github-ui/react-query'
import type {MilestoneState} from '@github-ui/server-persisted-queries/types/RepositoryMilestoneIndexPageQuery'
import {reactFetchJSON} from '@github-ui/verified-fetch'

export type ToggleMilestoneInput = {
  id: string
  number: number
  nameWithOwner: string
  state: MilestoneState
}

async function toggleMilestoneState({number, nameWithOwner, state}: ToggleMilestoneInput): Promise<void> {
  let response: Response
  try {
    response = await reactFetchJSON(`/${nameWithOwner}/milestones/${number}/state`, {
      method: 'PUT',
      body: {state},
    })
  } catch {
    throw new Error('Could not change Milestone state')
  }

  if (!response.ok) {
    throw new Error('Could not change Milestone state')
  }

  const result = await response.json()
  const errors = result.data?.updateMilestone?.errors
  if (!result.data?.updateMilestone?.milestone || (errors && errors.length > 0)) {
    throw new Error('Could not change Milestone state')
  }
}

export function useToggleMilestoneStateMutation({
  onError,
}: {
  onError?: (error: Error) => void
} = {}) {
  return useMutation<void, Error, ToggleMilestoneInput>({
    mutationFn: toggleMilestoneState,
    onError,
  })
}
